module.exports = __webpack_public_path__ + "static/img/COA_Bx_Carousel_6.e709797.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboarding/COA_Bx_Carousel_6.jpg
// module id = 213
// module chunks = 1